<template>
  <div class>
    <Toast />

    <div class="card">
      <h5>
        <b>Tambah Mutasi</b>
      </h5>
      <div class="p-grid p-mb-6">
        <div class="p-col-12">
          <AutoComplete
            placeholder="Pilih tipe"
            id="type"
            :dropdown="true"
            :multiple="false"
            v-model="selectedType"
            :suggestions="autoFiltered"
            @complete="searchType($event)"
            field="name"
          />
          <AutoComplete
            :disabled="selectedType == null"
            :style="'margin-left: 10px'"
            placeholder="Pilih Kode Mutasi"
            id="mutation_codes"
            :dropdown="true"
            :multiple="false"
            v-model="selectedPurchase"
            :suggestions="purchaseFiltered"
            @complete="filterInitialPurchaseOrder($event)"
            field="mutation_code"
          />
          <Button
            :style="'margin-left: 10px'"
            :disabled="buttonBon"
            label="Tambah Mutasi"
            @click="addNewRowPurchase(selectedPurchase.id)"
          >
            <span v-if="buttonBon_loading" class="p-d-flex p-ai-center">
              <i class="pi pi-spin pi-spinner p-ml-2"></i>
            </span>
          </Button>
          <Button
            :style="'margin-left: 10px'"
            :disabled="buttonCalculate"
            label="Total Per Outlet"
            @click="calculateTotalQtyPerOutlet()"
          >
          </Button>
        </div>
        <Message
          v-if="failingRowsSummary.length > 0"
          severity="warn"
          :closable="false"
        >
          <span>{{ failingRowsSummary.length }} baris bermasalah:</span>
          <a
            v-for="failingRow in failingRowsSummary"
            :key="failingRow.index"
            href="#"
            class="failing-row-chip"
            @click.prevent="scrollToRow(failingRow.index)"
            >{{ failingRow.label }}</a
          >
        </Message>
        <div class="p-col-12" style="overflow-x: auto">
          <table class="table table-responsive table-bordered">
            <thead class="thead-light">
              <tr>
                <th>No</th>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Harga (Rp)</th>
                <th>Diskon</th>
                <th>Qty Awal</th>
                <th
                  style="font-size: 12px; text-align: center"
                  v-for="(item, r) in outlets"
                  :key="r"
                >
                  <span>{{ item.alias }}</span>
                </th>
                <th>Qty Akhir</th>

                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in items_temp" :key="k" :ref="'row-' + k">
                <!-- No -->
                <td>
                  {{ k + 1 }}
                </td>
                <!-- Kode Barang -->
                <td>
                  <div class="item">
                    <AutoComplete
                      placeholder="Kode Barang"
                      id="code"
                      :dropdown="true"
                      :multiple="false"
                      v-model="an_item.dropdownItem"
                      :suggestions="dropdownItems"
                      @input="chooseDropdownChanges(k, an_item)"
                      @complete="getDetailPurchase(k)"
                      @keyup.enter="nextFocusItemCode"
                      field="code"
                      autofocus
                    />
                  </div>
                  <small class="p-error" v-if="isError.items[k].kode_barang">{{
                    error_msg.items[k].kode_barang
                  }}</small>
                </td>
                <!-- Nama Barang -->
                <td>
                  <div class="item">
                    <InputText
                      :readonly="true"
                      class="form-control"
                      id="item_name"
                      type="text"
                      v-model="an_item.item_name"
                      placeholder="Nama Barang"
                    />
                  </div>
                </td>
                <td>
                  <!-- Harga Rp -->
                  <div class="item">
                    <InputNumber
                      :value="an_item.priceInRp ? an_item.priceInRp : 0"
                      locale="id-ID"
                      :id="'data-price-' + k"
                      :disabled="selectedType.code === 'GIFT_MUTATION'"
                      :min="0"
                      mode="decimal"
                      placeholder="0"
                      @keyup.prevent="
                        selectedType.code === 'SPECIAL_MUTATION'
                          ? setValuePriceSpecialMutation(k, an_item)
                          : ValidateCapPrice(k, an_item)
                      "
                    />
                  </div>
                  <small
                    class="p-warning"
                    v-if="isError.items[k].price && profit_error[k]"
                    >{{ error_msg.items[k].price }}</small
                  >
                  <small
                    class="p-error"
                    v-else-if="isError.items[k].price && !profit_error[k]"
                    >{{ error_msg.items[k].price }}</small
                  >
                </td>
                <td>
                  <!-- Diskon -->
                  <div class="qty-awal">
                    <InputText
                      :style="'width: 50px'"
                      id="item-discount"
                      v-model="an_item.discount"
                      :disabled="selectedType.code == 'GIFT_MUTATION'"
                      :min="0"
                      :type="'number'"
                      :max="100"
                      placeholder="0"
                      @keyup.enter="nextFocusDiscount($event, k)"
                    />
                  </div>
                  <small class="p-error" v-if="isError.items[k].discount">{{
                    error_msg.items[k].discount
                  }}</small>
                </td>
                <!-- Qty Awal -->
                <td>
                  <div class="qty-awal">
                    <InputText
                      :readonly="true"
                      class="form-control"
                      id="available-qty"
                      type="number"
                      v-model="an_item.qty"
                      placeholder="0"
                    />
                  </div>
                </td>
                <!-- Qty Outlet -->
                <td v-for="(outlet, r) in an_item.warehouse_outbounds" :key="r">
                  <tr v-if="selectedType.code == 'SPECIAL_MUTATION'">
                    <div class="qty">
                      <InputText
                        class="form-control low-opacity"
                        id="outlet-qty"
                        type="number"
                        v-model="outlet.qty"
                        :ref="`input-${r}`"
                        min="0"
                        step="1"
                        v-bind:placeholder="outlets[r].alias"
                        @keyup.prevent="calculateTotal(k, r)"
                        @keyup.enter="nextFocusQty($event, k)"
                      />
                    </div>
                    <small class="p-error" v-if="outlet.err_qty.qty">{{
                      outlet.err_qty.msg
                    }}</small>
                  </tr>
                  <tr v-else>
                    <div class="qty">
                      <InputText
                        class="form-control low-opacity"
                        id="outlet-qty"
                        type="number"
                        v-model="outlet.qty"
                        :ref="`input-${r}`"
                        min="0"
                        v-bind:placeholder="outlets[r].alias"
                        @keyup.prevent="calculateTotal(k, r)"
                        @keyup.enter="nextFocusQtyElse($event, k)"
                      />
                    </div>
                    <small class="p-error" v-if="outlet.err_qty.qty">{{
                      outlet.err_qty.msg
                    }}</small>
                  </tr>
                  <!-- price for special mutation below qty -->
                  <tr v-if="selectedType.code == 'SPECIAL_MUTATION'">
                    <div class="priceCol">
                      <div style="height: 100%">
                        <InputNumber
                          locale="id-ID"
                          v-model="outlet.price"
                          :min="0"
                          placeholder="0"
                          @blur="updatePrice($event, outlet, k)"
                          @keyup.enter="nextFocusPriceOutlet()"
                          class="opacity-number"
                        />
                      </div>
                    </div>
                  </tr>
                </td>
                <td>
                  <div class="total-qty">
                    <InputText
                      :readonly="true"
                      class="form-control"
                      id="total-qty"
                      type="number"
                      placeholder="0"
                      v-model="an_item.total"
                    />
                  </div>
                  <small class="p-error" v-if="isError.items[k].qty">{{
                    error_msg.items[k].qty
                  }}</small>
                </td>
                <td class="trashIconContainer">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="deleteRow(k, an_item)"
                  ></Button>
                </td>
              </tr>
              <tr v-if="items_temp.length > 0">
                <td colspan="4"></td>
                <td colspan="1" style="text-align: center; font-weight: bold">
                  Total Qty
                </td>
                <td>
                  <InputText
                    :disabled="true"
                    class="form-control"
                    :value="qtyAwalTotal ? qtyAwalTotal : 0"
                  />
                </td>
                <td v-for="(item, r) in qtyOutletTotal" :key="r">
                  <InputText
                    :disabled="true"
                    class="form-control"
                    :value="item"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <br /><br /><br /><br /><br />
        </div>
      </div>
      <Dialog header="Konfirmasi" :visible.sync="showConfirmation" modal>
        <ItemMutationConfirmation
          :items="items_temp"
          :input-data="inputData"
          @close="showConfirmation = false"
          @modal-closed="handleModalClosed"
        />
      </Dialog>
      <template>
        <div class="p-d-flex p-jc-between">
          <div style="margin: auto">
            <Button
              v-if="items_temp.length != 0"
              type="button"
              label="Simpan"
              :disabled="save_button"
              @click="submit()"
            >
              <span v-if="loading_simpan" class="p-d-flex p-ai-center">
                Simpan
                <i class="pi pi-spin pi-spinner p-ml-2"></i>
              </span>
            </Button>
          </div>
          <div>
            <Button
              icon="pi pi-plus"
              :disabled="selectedType == null"
              label="Tambah"
              class="p-mr-2"
              @click="addNewRow()"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Dialog from 'primevue/dialog'
import ItemMutationConfirmation from '../item-mutation/Confirmation.vue'
export default {
  components: {
    Dialog,
    ItemMutationConfirmation
  },
  data() {
    return {
      selectedType: null,
      selectedTypes: [
        { id: 1, code: 'REGULAR_MUTATION', name: 'Mutasi Regular' },
        { id: 2, code: 'SPECIAL_MUTATION', name: 'Mutasi Spesial' },
        { id: 3, code: 'SALE_MUTATION', name: 'Mutasi Obral' },
        { id: 4, code: 'GIFT_MUTATION', name: 'Mutasi Hadiah' }
      ],
      autoFiltered: [],
      dropdownItems: null,
      loading_simpan: false,
      outlets: [],
      items_checked: false,
      isError: {
        items: [
          {
            kode_barang: false,
            price: false,
            discount: false,
            qty: false
          }
        ],
        price: []
      },
      error_msg: {
        items: [
          {
            kode_barang: '',
            price: '',
            discount: '',
            qty: ''
          }
        ]
      },
      showConfirmation: false,
      itemProp: [],
      inputData: {
        type: '',
        items: []
      },
      items_temp: [],
      price_is_null: true,
      gift_setting: false,
      save_button: true,
      initial_purchase_orders: [],
      purchaseFiltered: [],
      selectedPurchase: null,
      purchase_orders: [],
      buttonBon: true,
      buttonBon_loading: false,
      buttonCalculate: true,
      qtyOutletTotal: [],
      qtyAwalTotal: 0,
      newPrice: 0,
      profit_error: [],
      // Every items_temp index that failed at least one check in the most
      // recent submit() call, in order. Built by submit() itself (it's
      // the only place with a full picture of every row's outcome);
      // consumed by the failure-UX added in later tasks.
      failingRowIndexes: []
    }
  },

  mounted() {
    this.getOutlets()
    this.getInitialPurchaseOrders()
  },

  watch: {
    user() {
      this.getAuthUser()
    },
    items_temp() {
      if (this.items_temp.length > 0) {
        this.buttonCalculate = false
      }
    }
  },

  computed: {
    ...mapState(['user', 'isAuthenticated']),
    // Display list for the failing-rows banner: row number (1-based, to
    // match the "No" column shown in the table) plus the item code when
    // one's been picked, built from failingRowIndexes (submit()).
    failingRowsSummary() {
      return this.failingRowIndexes.map(index => ({
        index,
        label: this.rowLabel(index)
      }))
    }
  },

  methods: {
    getAuthUser() {
      console.info(this.user)
    },

    searchType(event) {
      this.autoFiltered = this.selectedTypes.filter(item => {
        return (
          item.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
          item.code.toLowerCase().startsWith(event.query.toLowerCase())
        )
      })
    },

    nextFocusQty(event) {
      event.target.parentElement.parentElement.nextElementSibling.children[0].children[0].nextElementSibling.focus()
    },

    nextFocusQtyElse(event, index) {
      if (
        event.target.parentElement.parentElement.parentElement
          .nextElementSibling.children[0].children[0].id == 'total-qty'
      ) {
        event.target.parentElement.parentElement.parentElement.nextElementSibling.nextElementSibling.children[0].children[0].nextElementSibling.focus()
        if (this.selectedType.code == 'GIFT_MUTATION') {
          this.addNewRow()
          setTimeout(() => {
            event.target.parentElement.parentElement.parentElement.parentElement.parentElement.children[
              index + 1
            ].children[0].nextElementSibling.children[0].children[0].children[0].focus()
          }, 0)
        }
      } else {
        event.target.parentElement.parentElement.parentElement.nextElementSibling.children[0].children[0].children[0].focus()
      }
    },

    nextFocusItemCode(event) {
      event.target.parentElement.parentElement.parentElement.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.children[0].children[0].children[0].focus()
    },

    filterPriceNull() {
      //* false = old item
      //* true = new item (not distributed yet)
      //* none = all item (new and old)
      if (
        this.selectedType.code == 'SPECIAL_MUTATION' ||
        this.selectedType.code == 'REGULAR_MUTATION'
      ) {
        this.price_is_null = ''
      } else if (this.selectedType.code == 'SALE_MUTATION') {
        this.price_is_null = false
      } else {
        this.price_is_null = true
      }
    },

    setGiftSetting() {
      // for gift setting
      if (this.selectedType.code == 'GIFT_MUTATION') {
        this.gift_setting = true
      } else {
        this.gift_setting = false
      }
    },

    updatePrice(event, outlet, index) {
      const formattedValue = event.target.value
        .replace(/\./g, '')
        .replace(',', '.')
      outlet.price = formattedValue
      // Keep priceInRp in sync with the per-outlet edit — otherwise the
      // top price field keeps displaying a stale value after this blur,
      // and it drifts out of sync with what's actually being submitted.
      if (typeof index === 'number' && this.items_temp[index]) {
        this.items_temp[index].priceInRp = formattedValue
      }
      this.$forceUpdate()
    },

    // "Baris N (CODE)" (or just "Baris N" before an item's been picked)
    // — the 1-based row number matches the "No" column already shown in
    // the table. Shared by the failing-rows banner and the row-specific
    // toasts below, so both say the same thing about the same row.
    rowLabel(index) {
      const item = this.items_temp[index]
      const code = item && item.dropdownItem ? item.dropdownItem.code : null
      return code ? `Baris ${index + 1} (${code})` : `Baris ${index + 1}`
    },

    // Scrolls the given items_temp row into view and focuses its first
    // input, so a failed submit on a long (20+ row) table doesn't leave
    // the user to hunt for which row is red. No scrollIntoView/$refs
    // precedent existed anywhere in this codebase for this purpose —
    // deliberately not built on the existing fragile
    // event.target.parentElement... DOM-chain style used by the
    // nextFocus* methods elsewhere in this file.
    scrollToRow(index) {
      if (typeof index !== 'number') {
        return
      }
      this.$nextTick(() => {
        const rowRef = this.$refs['row-' + index]
        const rowEl = Array.isArray(rowRef) ? rowRef[0] : rowRef
        if (!rowEl || typeof rowEl.scrollIntoView !== 'function') {
          return
        }
        rowEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
        const focusable = rowEl.querySelector('input, textarea, select')
        if (focusable && typeof focusable.focus === 'function') {
          focusable.focus()
        }
      })
    },

    nextFocusPriceOutlet(event) {
      if (
        event.target.parentElement.parentElement.parentElement
          .nextElementSibling.children[0].children[0].id == 'total-qty'
      ) {
        event.target.parentElement.parentElement.parentElement.nextElementSibling.nextElementSibling.children[0].children[0].nextElementSibling.focus()
      } else {
        event.target.parentElement.parentElement.parentElement.nextElementSibling.children[0].children[0].children[0].focus()
      }
    },

    nextFocusDiscount(event, index) {
      this.addNewRow()
      setTimeout(() => {
        event.target.parentElement.parentElement.parentElement.children[
          index + 1
        ].children[0].nextElementSibling.children[0].children[0].children[0].focus()
      }, 0)
    },

    getDetailPurchase(index) {
      this.filterPriceNull()
      this.setGiftSetting()
      let code = ''
      if (this.items_temp[index].dropdownItem != undefined) {
        if (this.items_temp[index].dropdownItem instanceof Object) {
          code = this.items_temp[index].dropdownItem.code
        } else {
          code = this.items_temp[index].dropdownItem
        }
      }

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/warehouse-items?code=${code}&name=&include_empty_stock=&page=&limit=5&price_is_null=${this.price_is_null}&gift_items=${this.gift_setting}`
        )
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            this.dropdownItems = response.data.data.items
          } else {
            console.error('gagal get')
          }
        })
    },

    async getOutlets() {
      this.loading = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets`
        )
        this.loading = false
        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        } else {
          console.error('Gagal mendapatkan data outlet')
        }
      } catch (error) {
        this.loading = false
        console.error('Error fetching outlets:', error)
      }
    },

    chooseDropdownChanges(index, an_item) {
      this.isError.items[index].kode_barang = false
      this.save_button = false
      let hasDuplicate = false

      // Filter out deleted items from the comparison
      const filteredItems = this.items_temp.filter(
        (item, i) => item.dropdownItem && i !== index
      )

      if (filteredItems.length > 0) {
        for (const item of filteredItems) {
          if (item.dropdownItem.id === an_item.dropdownItem.id) {
            hasDuplicate = true
            break
          }
        }
      }

      if (hasDuplicate) {
        this.showToast(
          'error',
          'Item Is Already Exist',
          'Barang sudah ada di daftar'
        )
        this.save_button = true
        this.isError.items[index].kode_barang = true
        this.error_msg.items[index].kode_barang = 'Barang sudah ada di daftar'
      } else {
        // Jika tidak ada duplikasi, perbarui item
        this.items_temp[index].dropdownItem = an_item.dropdownItem
        this.items_temp[index].item_name = an_item.dropdownItem.name
        this.items_temp[index].qty = an_item.dropdownItem.stock
          ? an_item.dropdownItem.stock
          : 0
        this.items_temp[index].total = an_item.dropdownItem.stock
        this.items_temp[index].cap_price = an_item.dropdownItem.cap_price
        this.items_temp[index].cap_priceRP =
          'Rp ' + this.formatPrice(this.items_temp[index].cap_price)
        this.items_temp[index].price = parseInt(an_item.dropdownItem.price)
        for (const outlet of this.items_temp[index].warehouse_outbounds) {
          outlet.price = parseInt(this.items_temp[index].price)
        }
        this.items_temp[index].priceInRp = this.items_temp[index].price
        // this.items_temp[index].priceInRp = this.items_temp[index].cap_price
        this.items_temp[index].item_id = an_item.dropdownItem.id
      }

      this.calculateQtyawalTotal()
    },

    calculateQtyawalTotal() {
      this.qtyAwalTotal = this.items_temp.reduce(
        (total, item) => total + item.qty,
        0
      )
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    async backFromConfirmation(item) {
      this.selectedTypes.code = this.itemPropReturn.type
      let tmp = this.itemPropReturn
      this.items_temp.push({
        item_name: { name: item.item_name },
        item_id: tmp[0].id,
        generateCode: true,
        code: '',
        name: item.item_name,
        warehouse_outbounds: this.outlets.map(outlet => ({
          id: 0,
          outlet_id: outlet.id,
          qty: null,
          err_qty: {
            qty: false,
            msg: ''
          },
          price: parseInt(tmp[0].price)
        })),
        newItem: true,
        dropdownItem: tmp[0], // <- catch first data
        qty: tmp[0].stock,
        total: tmp[0].stock,
        priceInRp: parseInt(tmp[0].price),
        discount: null
      })

      this.isError.items.push({
        kode_barang: false,
        price: false,
        discount: false
      })

      this.error_msg.items.push({
        kode_barang: '',
        price: '',
        discount: ''
      })
    },

    async addNewRowPurchase(id) {
      this.save_button = false
      this.buttonBon = true
      this.buttonBon_loading = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders?init_id=${id}`
        )

        if (response.status !== 200) {
          console.error('Error:', response)
          return
        }

        //remove init_id from initial_purchase_orders
        this.removeInitPurcahseOrderById(id)

        this.purchase_orders = response.data.data.purchase_orders
        await this.processItemsInBatches(this.purchase_orders)

        this.selectedPurchase = null
        this.calculateQtyawalTotal()
      } catch (error) {
        console.error('Error:', error)
      }
      this.buttonBon_loading = false
    },

    removeInitPurcahseOrderById(id) {
      const idx = this.initial_purchase_orders.findIndex(item => item.id == id)
      if (idx !== -1) {
        this.initial_purchase_orders.splice(idx, 1)
      }
    },

    async processItemsInBatches(items) {
      for (let i = 0; i < items.length; i++) {
        await this.processWarehouseItem(items[i])
      }
    },

    async processWarehouseItem(item) {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/warehouse-items/${item.item_id}`
        )

        if (response.status !== 200) {
          console.error('Error:', response)
          return
        }

        const tmp = response.data.data.item

        let outlets = this.outlets.map(outlet => ({
          id: 0,
          outlet_id: outlet.id,
          qty: null,
          err_qty: {
            qty: false,
            msg: ''
          },
          price: Number(tmp.price)
        }))

        this.items_temp.push({
          item_name: item.item_name,
          item_id: item.item_id,
          generateCode: true,
          code: '',
          name: item.item_name,
          warehouse_outbounds: outlets,
          newItem: true,
          dropdownItem: tmp, // <- catch first data
          qty: tmp.stock,
          total: tmp.stock,
          priceInRp: parseInt(tmp.price),
          discount: null
        })

        this.isError.items.push({
          kode_barang: false,
          price: false,
          discount: false
        })

        this.error_msg.items.push({
          kode_barang: '',
          price: '',
          discount: ''
        })
      } catch (error) {
        console.error('Error processing warehouse item:', error)
      }
    },

    addNewRow() {
      let tmp = []

      for (const item of this.outlets) {
        tmp.push({
          id: 0,
          outlet_id: item.id,
          qty: null,
          price: 0,
          err_qty: {
            qty: false,
            msg: ''
          }
        })
      }

      this.items_temp.push({
        item_name: null,
        item_id: '',
        generateCode: true,
        code: '',
        name: '',
        warehouse_outbounds: tmp,
        newItem: true,
        dropdownItem: null,
        qty: null,
        total: null,
        priceInRp: null,
        discount: null
      })

      this.isError.items.push({
        kode_barang: false,
        price: false,
        discount: false
      })

      this.error_msg.items.push({
        kode_barang: '',
        price: '',
        discount: ''
      })
    },

    deleteRow(index, an_item) {
      let idx = this.items_temp.indexOf(an_item)
      if (idx > -1) {
        this.items_temp.splice(idx, 1)
        this.isError.items.splice(idx, 1)
        this.error_msg.items.splice(idx, 1)
        // profit_error must shift in sync with items_temp too, or every
        // row after the deleted one ends up validated against the wrong
        // row's profit_error state.
        this.profit_error.splice(idx, 1)
      }
      this.calculateQtyawalTotal()
    },

    submit() {
      this.inputData.items = []
      this.inputData.type = ''
      this.items_checked = true
      this.failingRowIndexes = []

      this.inputData.type = this.selectedType.code
      for (let i = 0; i < this.items_temp.length; i++) {
        let item = this.items_temp[i]
        // Local mirror of items_checked, scoped to this row only — lets
        // us record which specific rows failed (failingRowIndexes)
        // instead of just the fact that *something* failed somewhere.
        let rowHasError = false
        // Set below only when THIS row's cap-price check (this call)
        // flags a violation — guards the price==0 check further down
        // from unconditionally clearing it back out.
        let priceCapViolationThisRow = false
        if (item.dropdownItem == null) {
          this.isError.items[i].kode_barang = true
          this.error_msg.items[i].kode_barang = 'mohon pilih kode barang'
          this.items_checked = false
          rowHasError = true
        }

        this.itemProp = item
        if (
          this.inputData.type == 'REGULAR_MUTATION' ||
          this.inputData.type == 'SPECIAL_MUTATION'
        ) {
          // error price
          if (Number(item.priceInRp) <= Number(item.cap_price)) {
            this.isError.items[i].price = true
            this.error_msg.items[i].price =
              'harga jual harus lebih besar dari harga modal'
            this.items_checked = false
            rowHasError = true
            priceCapViolationThisRow = true
          } else {
            this.isError.items[i].price = false
          }

          // SPECIAL_MUTATION lets each outlet's price be edited
          // independently (updatePrice(), on blur) — the row-level
          // priceInRp check above never sees those edits. Validate every
          // outlet actually being submitted (qty > 0) against cap_price
          // too, since that per-outlet price is what's actually
          // persisted and neither this check nor the backend validates
          // it otherwise.
          if (
            this.inputData.type == 'SPECIAL_MUTATION' &&
            !priceCapViolationThisRow
          ) {
            for (const outlet of item.warehouse_outbounds) {
              if (
                Number(outlet.qty) > 0 &&
                Number(outlet.price) <= Number(item.cap_price)
              ) {
                this.isError.items[i].price = true
                this.error_msg.items[i].price =
                  'harga jual harus lebih besar dari harga modal'
                this.items_checked = false
                rowHasError = true
                priceCapViolationThisRow = true
                break
              }
            }
          }

          // error qty awal < qty akhir
          if (item.qty < item.total) {
            this.isError.items[i].qty = true
            this.error_msg.items[i].qty =
              'qty akhir tidak boleh lebih besar dari qty awal'
            this.items_checked = false
            rowHasError = true
          } else {
            this.isError.items[i].qty = false
          }
        }

        if (item.discount > 100) {
          this.isError.items[i].discount = true
          this.error_msg.items[i].discount = 'diskon > 100'
          this.items_checked = false
          rowHasError = true
        }

        if (item.discount < 0) {
          this.isError.items[i].discount = true
          this.error_msg.items[i].discount = 'diskon < 0'
          this.items_checked = false
          rowHasError = true
        }

        this.inputData.items.push({
          item_id: '',
          price: '',
          discount: null,
          warehouse_outbounds: []
        })

        this.inputData.items[i].item_id = item.item_id
        this.inputData.items[i].price = item.priceInRp
        if (item.discount == null || item.discount == '') {
          this.inputData.items[i].discount = 0
        } else {
          this.inputData.items[i].discount = parseInt(item.discount)
        }
        if (
          this.inputData.items[i].price == 0 &&
          this.inputData.type != 'GIFT_MUTATION'
        ) {
          this.isError.items[i].price = true
          this.error_msg.items[i].price = 'Harga tidak boleh kosong'
          this.items_checked = false
          rowHasError = true
        } else if (!priceCapViolationThisRow) {
          // Only clear here if the cap-price check above didn't just
          // flag this same row — otherwise this unconditionally wiped
          // out a real cap-price violation on every row where price
          // isn't literally 0, which is the realistic case.
          this.isError.items[i].price = false
          this.error_msg.items[i].price = ''
        }

        let atLeastOneQtyGreaterThanZero = false
        this.inputData.items[i].warehouse_outbounds = []
        for (const warehouseOutbound of item.warehouse_outbounds) {
          let qty = 0
          if (warehouseOutbound.qty) {
            qty = warehouseOutbound.qty
          }

          // validate to push only if qty > 0
          if (qty > 0) {
            this.inputData.items[i].warehouse_outbounds.push({
              outlet_id: warehouseOutbound.outlet_id,
              qty: Number(qty),
              purchase_id: this.purchase_orders[i]
                ? parseInt(this.purchase_orders[i].id)
                : null,
              price: warehouseOutbound.price
            })
            atLeastOneQtyGreaterThanZero = true
          }
        }

        // Handle error if no qty > 0
        if (!atLeastOneQtyGreaterThanZero) {
          this.isError.items[i].kode_barang = true
          this.error_msg.items[i].kode_barang = 'Qty tidak boleh kosong'
          this.items_checked = false
          rowHasError = true
        } else {
          this.isError.items[i].kode_barang = false
          this.error_msg.items[i].kode_barang = ''
        }

        if (rowHasError) {
          this.failingRowIndexes.push(i)
        }
        if (item.dropdownItem) {
          this.items_temp[i].code = item.dropdownItem.code
        }
      }

      if (this.items_checked) {
        this.showConfirmation = true
      } else {
        // One summary toast for the whole submit attempt, not one per
        // field — submit() previously showed nothing at all on failure,
        // leaving items_checked silently false with no feedback beyond
        // whatever inline messages happened to be visible.
        const rowCount = this.failingRowIndexes.length
        this.showToast(
          'error',
          'Periksa Kembali',
          `${rowCount} baris bermasalah — cek kolom yang ditandai merah`
        )
        this.scrollToRow(this.failingRowIndexes[0])
      }
    },

    handleModalClosed(success) {
      setTimeout(() => {
        if (success) {
          this.clearData()
        }
        this.showConfirmation = false
      }, 500)
    },

    calculateProfitPerItems(item) {
      // hitung profit 50% dari harga jual
      // rumus harga jual = harga modal + (harga modal * presentase profit / 100)
      const profit =
        parseInt(item.dropdownItem.cap_price) +
        parseInt(item.dropdownItem.cap_price) *
          (this.user.profit_percentage / 100)
      return profit
    },

    clearData() {
      this.items_temp = []
      this.selectedType = null
      this.isError.items.push({
        kode_barang: false,
        price: false
      })
      this.error_msg.items.push({
        kode_barang: '',
        price: ''
      })
      this.dropdownSupplier = null
      this.inputData.items = []
      this.inputData.type = ''
      this.selectedPurchase = null
      this.qtyOutletTotal = 0
    },

    ValidateCapPrice(index, item) {
      setTimeout(() => {
        const priceElement = document.getElementById('data-price-' + index)
        const priceValue = priceElement.value.replace(/\./g, '')
        const parsedPrice = parseInt(priceValue) ? parseInt(priceValue) : 0
        const profit = this.calculateProfitPerItems(item)

        // Initialize the error arrays if not already done
        if (!this.profit_error[index]) {
          this.$set(this.profit_error, index, false)
        }

        if (isNaN(parsedPrice) && this.selectedType.code === 'SALE_MUTATION') {
          this.showPriceError(index, 'Harga jual harus berupa angka')
        } else if (parsedPrice <= parseInt(item.dropdownItem.rise_cap_price)) {
          this.showPriceError(index, 'Harga jual harus > harga modal')
          // profit_error is an array — Vue 2 cannot detect a plain bracket
          // assignment on an array index (Vue.set/splice is the only
          // reactive path for arrays), so this must go through $set or the
          // p-warning/p-error <small> below can silently show the wrong
          // branch.
          this.$set(this.profit_error, index, false)
        } else if (parsedPrice <= profit) {
          this.showPriceError(index, 'Harga jual harus > profit')
          this.$set(this.profit_error, index, true)
        } else {
          this.isError.items[index].price = false
          this.error_msg.items[index].price = ''
          // Reset flag kesalahan
          this.isError.price[index] = false
        }
        this.items_temp[index].priceInRp = parsedPrice
      }, 500)
    },

    setValuePriceSpecialMutation(index, item) {
      setTimeout(() => {
        const priceElement = document.getElementById('data-price-' + index)
        const priceValue = priceElement.value.replace(/\./g, '')
        const parsedPrice = parseInt(priceValue) ? parseInt(priceValue) : 0
        const profit = this.calculateProfitPerItems(item)
        if (parsedPrice <= parseInt(item.dropdownItem.rise_cap_price)) {
          this.showPriceError(index, 'Harga jual harus > harga modal')
        } else if (parsedPrice <= profit) {
          this.showPriceError(index, 'Harga jual harus > profit')
        } else {
          this.isError.items[index].price = false
          this.error_msg.items[index].price = ''
          // Reset flag kesalahan
          this.isError.price[index] = false
        }
        this.items_temp[index].warehouse_outbounds.forEach(outlet => {
          outlet.price = parsedPrice
        })
        this.items_temp[index].priceInRp = parsedPrice
      }, 500)
    },

    showPriceError(index, message) {
      // Tampilkan pemberitahuan kesalahan hanya jika belum ditampilkan sebelumnya
      if (!this.isError.price[index]) {
        this.isError.price[index] = true
        this.isError.items[index].price = true
        this.error_msg.items[index].price = message
        // The inline message under the field is already scoped to its
        // row visually — the toast isn't, so it needs the row label to
        // be useful on its own.
        this.showToast(
          'error',
          'Kesalahan Harga',
          `${this.rowLabel(index)}: ${message}`
        )
      }
    },

    calculateTotal(index, indexOutlet) {
      let total = this.items_temp[index].qty
      const warehouseOutbounds = this.items_temp[index].warehouse_outbounds

      let totalOutlet = this.outlets.length
      for (let i = 0; i < totalOutlet; i++) {
        const outbound = warehouseOutbounds[i] // Cache the reference
        if (outbound.qty === '0') {
          outbound.qty = null
        }
        if (outbound.qty !== null) {
          total -= outbound.qty
        }
      }
      this.items_temp[index].total = total

      if (total < 0) {
        this.setErrorState(index, indexOutlet, 'qty akhir harus >= 0')
      } else {
        this.clearErrorState(index, indexOutlet)
      }

      // this.calculateTotalQtyPerOutlet()
    },

    setErrorState(index, indexOutlet, message) {
      this.isError.items[index].qty = true
      this.save_button = true
      this.error_msg.items[index].qty = message
      const outbound = this.items_temp[index].warehouse_outbounds[indexOutlet]
      outbound.err_qty.qty = true
      outbound.err_qty.msg = message
      this.showToast('error', 'Qty Error', message)
    },

    clearErrorState(index, indexOutlet) {
      this.save_button = false
      this.isError.items[index].qty = false
      this.error_msg.items[index].qty = ''
      const outbound = this.items_temp[index].warehouse_outbounds[indexOutlet]
      outbound.err_qty.qty = false
      outbound.err_qty.msg = ''
    },

    calculateTotalQtyPerOutlet() {
      const outletTotals = new Array(this.outlets.length).fill(0)

      this.items_temp.forEach(item => {
        item.warehouse_outbounds.forEach((outbound, i) => {
          if (
            outbound.qty !== '' &&
            outbound.qty !== null &&
            !isNaN(outbound.qty)
          ) {
            outletTotals[i] += parseInt(outbound.qty)
          }
        })
      })

      this.qtyOutletTotal = outletTotals.map(qty =>
        qty !== null && !isNaN(qty) ? qty : 0
      )
    },

    async getInitialPurchaseOrders() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/initial-purchase-orders?distribution_done=false&status=1`
        )
        if (response.status === 200) {
          this.initial_purchase_orders =
            response.data.data.initial_purchase_orders
        }
      } catch (error) {
        console.error('Error fetching initial purchase orders:', error)
      }
    },

    filterInitialPurchaseOrder(event) {
      this.buttonBon = false
      this.purchaseFiltered = this.initial_purchase_orders.filter(item => {
        const lowerCaseQuery = event.query.toLowerCase()
        return item.mutation_code.toLowerCase().startsWith(lowerCaseQuery)
      })
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.p-warning {
  color: #8b6901;
  padding: 5px;
  border-radius: 4px;
}

.failing-row-chip {
  display: inline-block;
  margin: 2px 4px;
  padding: 2px 8px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.08);
  text-decoration: none;
  cursor: pointer;
}

.failing-row-chip:hover {
  background: rgba(0, 0, 0, 0.16);
}

.low-opacity::placeholder {
  opacity: 0.3 !important;
}

.priceCol {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0.5rem;
  width: 200px;
}

::v-deep .opacity-number input::placeholder {
  opacity: 0.3;
}
.priceColSpecial {
  width: 100%;
}

.item-discount {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 30px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 200px;
}

.harga {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 120px;
}

.qty-awal {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 60px;
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.total-qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 60px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 5px solid #ddd;
  margin-right: 15px;
  margin-left: 15px;
}

.scrollable {
  display: inline-block;
}
/*
.priceCol div {
  margin-right: 5px;
} */
</style>
